var _rect, _rect2, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCallTaskLight = function SvgCallTaskLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#D0EED8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#328847"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 22C19.5435 22 17.9718 21.6111 16.4097 20.8333C14.8477 20.0556 13.4444 19.0444 12.2 17.8C10.9556 16.5556 9.94444 15.1523 9.16667 13.5903C8.38889 12.0282 8 10.4565 8 8.875C8 8.625 8.08333 8.41666 8.25 8.25C8.41666 8.08333 8.625 8 8.875 8H11.5972C11.7737 8 11.9312 8.06157 12.0698 8.18472C12.2085 8.30787 12.2972 8.47315 12.3361 8.68056L12.8611 11.1306C12.887 11.312 12.8838 11.4773 12.8514 11.6264C12.819 11.7755 12.7509 11.9019 12.6472 12.0056L10.7028 13.9694C11.4287 15.175 12.2421 16.225 13.1431 17.1194C14.044 18.0139 15.0648 18.7722 16.2056 19.3944L18.0528 17.4889C18.1824 17.3463 18.3315 17.2458 18.5 17.1875C18.6685 17.1292 18.837 17.1194 19.0056 17.1583L21.3194 17.6639C21.5179 17.7076 21.681 17.8061 21.8086 17.9592C21.9362 18.1123 22 18.2926 22 18.5V21.125C22 21.375 21.9167 21.5833 21.75 21.75C21.5833 21.9167 21.375 22 21.125 22ZM10.1194 12.9L11.6944 11.3056L11.2472 9.16667H9.16667C9.16667 9.67222 9.24444 10.2264 9.4 10.8292C9.55556 11.4319 9.79537 12.1222 10.1194 12.9ZM17.2944 19.9583C17.8259 20.2046 18.4028 20.4056 19.025 20.5611C19.6472 20.7167 20.25 20.8074 20.8333 20.8333V18.7528L18.8306 18.3444L17.2944 19.9583Z",
    fill: "#328847"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCallTaskLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/call-task-light.6d091b2d.svg";
export { ForwardRef as ReactComponent };